import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-settings-card-payments-section',
  templateUrl: './settings-card-payments-section.component.html',
  imports: [CommonModule, FormsModule],
  providers: [],
  standalone: true,
})
export class SettingsCardPaymentsSectionComponent {
  @Input({ required: true }) sectionTitle: string = '';
  @Input() addCSS: string = '';
  @Input() description: string = '';
  @Input() isThai: boolean = false;
}
